import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'
import Dashboard from '../views/Dashboard'
import Stats from '../views/Stats'

const AccountList = () => import('../views/AccountList.vue')
const NewAccount = () => import('../views/NewAccount.vue')
const ApiKeyList = () => import('../views/ApiKeyList.vue')
const UserList = () => import('../views/UserList.vue')
const ProgramList = () => import('../views/ProgramList.vue')
const LotList = () => import('../views/LotList.vue')
const PlanList = () => import('../views/PlanList.vue')
const NewPlan = () => import('../views/NewPlan.vue')
const ReservationList = () => import('../views/ReservationList.vue')
const BillsItems = () => import('../views/BillsItems.vue')
const BillsRow = () => import('../views/BillsRow.vue')
const BillsList = () => import('../views/BillsList.vue')
const NewBillsItem = () => import('../views/NewBillsItem.vue')
const EditBillsItem = () => import('../views/EditBillsItem.vue')
const AccountVue = () => import('../views/AccountVue.vue')
const NewDiscount = () => import('../views/NewDiscount.vue')
const ScrollList = () => import('../views/BillsList.vue')
const Mgc = () => import('../views/Mgc.vue')
const Banner = () => import('../views/Banner.vue')
const YousignStats = () => import('../views/YousignStats.vue')
const PreprodRefresh = () => import('../views/PreprodRefresh.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
    meta: {
      authRequired: false
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/stats',
    name: 'stats',
    component: Stats,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/accounts',
    name: 'accounts',
    component: AccountList,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/accounts/:id',
    name: 'accountVue',
    component: AccountVue,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/newDiscount',
    name: 'newDiscount',
    component: NewDiscount,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/newAccount',
    name: 'newAccount',
    component: NewAccount,
    meta: {
      authRequired: true
    }
  }, {
    path: '/mgc/:id',
    name: 'Mgc',
    component: Mgc,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/users',
    name: 'users',
    component: UserList,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/api-keys',
    name: 'apikeys',
    component: ApiKeyList,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/programs',
    name: 'programs',
    component: ProgramList,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/lots',
    name: 'lots',
    component: LotList,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/plans',
    name: 'plans',
    component: PlanList,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/newPlan',
    name: 'newPlan',
    component: NewPlan,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/reservations',
    name: 'reservations',
    component: ReservationList,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/billsItems',
    name: 'billsItems',
    component: BillsItems,
    meta: {
      parentName: 'billing'
    }
  },
  {
    path: '/billsRow',
    name: 'billsRow',
    component: BillsRow,
    meta: {
      parentName: 'billing'
    }
  },
  {
    path: '/billsList',
    name: 'billsList',
    component: BillsList,
    meta: {
      parentName: 'billing'
    }
  },
  {
    path: '/billing-items-create',
    name: 'newBillsItem',
    component: NewBillsItem,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/billing-items-edit',
    name: 'editBillsItem',
    component: EditBillsItem,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/bandeau',
    name: 'banner',
    component: Banner,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/stats/yousign',
    name: 'yousign',
    component: YousignStats,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/copie-preprod',
    name: 'preprodRefresh',
    component: PreprodRefresh,
    meta: {
      authRequired: true
    }
  },
  {
    path: '/scroll',
    name: 'scrollList',
    component: ScrollList,
    meta: {
      authRequired: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
